import styled from 'styled-components';

// Inline trigger so only the label text + icon are the hover target
// (not the full-width block label row).
export const LabelTrigger = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 3px;
  cursor: help;
`;

export const InfoIcon = styled.span`
  font-size: 13px;
  line-height: 1;
  /* The parent FieldLabel is uppercased with letter-spacing; both would
     mangle the material-symbols "info" ligature into literal text. */
  text-transform: none;
  letter-spacing: normal;
  color: ${({ theme: { colors = {} } }) => colors.onSurfaceVariant ?? '#A1A3B8'};
  opacity: 0.65;
  transition: opacity 120ms ease;

  ${LabelTrigger}:hover & {
    opacity: 1;
  }
`;
